import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const SearchIcon = (props) => {
  const {fill = '#848a93'} = props;
  return (
    <SvgIcon {...props} style={{ fill}} width="20.414" height="20.414" viewBox="0 0 20.414 20.414">
        <path id="Path_1178" data-name="Path 1178" d="M405,405l-6-6m2-5a7,7,0,1,1-7-7A7,7,0,0,1,401,394Z" transform="translate(-386 -386)" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </SvgIcon>
  );
};

export default SearchIcon;
